import * as React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { IListObj } from "../../../types/genericTypes";
import RadioButton from "../../../generic/radioButton";
import {
  createAccReq,
  getMemorandumDetails,
  getPaymentBankDetails,
  GetPersonDetails,
  paymentGateway,
  updateAccReactStatus,
} from "../../../service/serviceRequest/srApiService";
import InputField from "../../../generic/inputField";
import { upiExp } from "../../../utils/regex";
import { config } from "../../../../config/domain";
import { StatusScreen } from "../../generic/statusScreen";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
const payMethod: Array<IListObj> = [
  { value: "IB", display: "Internet Banking" },
  { value: "UPI", display: "UPI" },
  // { value: "QR", display: "UPI via QR code" },
];
export const AccountPayment = (props: any) => {
  const [bankUpiDetails, setBankUpiDetails] = useState<any>({
    bankDetails: [],
    upiDetails: [],
    upiHdlInfo: [],
  });
  const [payOption, setPayOption] = useState<any>([]);
  const [payModeDetails, setPaymentModeDetails] = useState<any>({
    isPrimUpi: false,
    bnkCode: "",
    amt: 0.0,
    bnkAccNo: "",
    bnkName: "",
    paymtMd: "",
    brcName: "",
    ldgrNm: "Normal",
    upi: "",
    app: "trade",
    isMmrdm: true,
    srId: "",
    accCode: "",
  });
  const RedirectnSource = window.localStorage.getItem("source");
  const [error, setError] = useState<any>({ handleError: "", upiError: "" });
  const [status, setStatus] = useState<any>();
  const [errorMsg, setErrorMsg] = useState<any>("");
  const [memorandumDetails, setMemorandumDetails] = useState<any>({
    memorandumId: "",
    Total_NET_Outstanding: "",
  });
  const [hover, setHover] = useState<boolean>(false);

  function redirect(url: string) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    }
  }
  React.useEffect(() => {
    if (
      memorandumDetails.Total_NET_Outstanding > 0 &&
      memorandumDetails.Total_NET_Outstanding < 50
    )
      setErrorMsg(
        "Minimum transfer amount is Rs.50. Please contact your RM or write us on helpdesk@nuvama.com"
      );
    showBankListed();
  }, [memorandumDetails.Total_NET_Outstanding]);
  React.useEffect(() => {
    if (props.paymentStatus) {
      switch (props.paymentStatus.bankstatus) {
        case "Processed":
          let accReactParentDetails: any = localStorage.getItem(
            "accReactParentDetails"
          );
          accReactParentDetails = JSON.parse(accReactParentDetails);

          const ckycDet = props.childSrList.find(
            (ele: any) => ele.RequestType === "CKYC Update"
          );

          let reqObj = {
            ckycSRId: ckycDet?.RequestId ? ckycDet.RequestId : 0,
            ckycStatus: ckycDet?.RequestStatus ? ckycDet.RequestStatus : "None",
            requestType: "PaymentSuccess",
            dormant_type: accReactParentDetails.dormant_type,
            parent_id: props.srId,
          };
          updateAccReactStatus(reqObj)
            .then((res) => {
              if (res && res.Message === "Payment Success!!!") {
                localStorage.removeItem("paymentReponse");
                redirect(
                  config.root + "app/clientarea/service-request?mod=accReactPay&source=" +
                  ( window.location.href.includes("source=ajs") ? "nsdl_ajs" : "nsdl_onep")
                  + "&appID=" + btoa(props.srId)
                );
              } else accountApiError();
            })
            .catch((err: any) => accountApiError());

          break;
        case "Pending":
        case "In Process":
          setStatus("Pending");
          break;
        case "Cancelled":
        case "Rejected":
        case "Request_Sent":
          setStatus("Success");
          break;
        case "Failed":
          setStatus("Rejected");
          break;
      }
    } else {
      getpaymentDetails();
    }
  }, []);
  const accountApiError = () => {
    props.onSubmit("AccountPayment", {
      headerText: "There was some problem during account reactivation process.",
    });
  };
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("accPayment", {
      headerText: "You have an active service request",
      content: "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
  };

  const getpaymentDetails = async () => {
    try {
      let resTotalNet = await getMemorandumDetails();
      const serviceList = await asyncGetServiceRequest(props.srId);
      const createSRPayment = serviceList.find(
        (list: any) => list.RequestType === "Memorandum Recovery"
      );
      if (
        resTotalNet &&
        Number(resTotalNet.result[0].Total_NET_Outstanding) > 0
      ) {
        if (!createSRPayment) {
          let reqObj = {
            requestType: "Memorandum",
            dpID: "None",
            dormant_type: "1",
            npa_outstanding: resTotalNet.result[0].NetNPA_Outstanding,
            memorandum_outstanding:
              resTotalNet.result[0].NetMemorandum_Outstanding,
            total_outstanding: resTotalNet.result[0].Total_NET_Outstanding,
            parent_id: props.srId,
          };
          let reqMemorandum = await createAccReq(reqObj);
          if (
            typeof reqMemorandum === "string" &&
            reqMemorandum.includes(
              "Previous Request already open for this account-"
            )
          ) {
            openExistSrPopup();
            return;
          } else {
            if (
              reqMemorandum &&
              reqMemorandum.Message === "Memorandum SR created successfully"
            ) {
              setMemorandumDetails({
                ...memorandumDetails,
                memorandumId: reqMemorandum.Id,
                Total_NET_Outstanding:
                  resTotalNet.result[0].Total_NET_Outstanding,
              });
            }
          }
        } else {
          setMemorandumDetails({
            ...memorandumDetails,
            memorandumId: createSRPayment.RequestId,
            Total_NET_Outstanding: resTotalNet.result[0].Total_NET_Outstanding,
          });
        }
      } else {
        props.setLoader(false);
        accountApiError();
      }
      props.setLoader(false);
    } catch (error) {
      props.setLoader(false);
      accountApiError();
    }
  };
  const showBankListed = async () => {
    try {
      let personaldetails = await GetPersonDetails();
      if (personaldetails && personaldetails.accountCodeField) {
        let queryPramas = `/${personaldetails.accountCodeField}?rTyp=PAYIN&APP=trade?ismrd=true`;
        let response = await getPaymentBankDetails(queryPramas);
        let resPayment: any = JSON.parse(response.data.details);
        if (resPayment && resPayment.bnkAcs) {
          var bankDetailsList = [];
          for (let i = 0; i < resPayment.bnkAcs.length; i++) {
            let api = {
              ...resPayment.bnkAcs[i],
              value: resPayment.bnkAcs[i].bnkAccNo,
              display: resPayment.bnkAcs[i].bnkName,
            };
            bankDetailsList.push(api);
          }
          setBankUpiDetails({
            ...bankUpiDetails,
            bankDetails: bankDetailsList,
            upiDetails: resPayment.upis,
            upiHdlInfo: resPayment.upiHdlInfo,
          });

          setPayOption([bankDetailsList[0]]);
          var autoSelectBank: any = {};
          if (bankDetailsList[0].fndTrsAvl) autoSelectBank.paymtMd = "IB";
          else if (bankDetailsList[0].upiintent) autoSelectBank.paymtMd = "UPI";
          // else if (bankDetailsList[0].upiqr && bankDetailsList[0].upiAvl)
          //   autoSelectBank.paymtMd = "QR";
          else autoSelectBank.paymtMd = undefined;

          if (memorandumDetails.Total_NET_Outstanding > 50) {
            if (!autoSelectBank.paymtMd)
              setErrorMsg(
                "We do not have instant fund transfer facility available with the selected bank currently, please try after sometime or you can connect with your respective RM for cheque based payment facility."
              );
          }

          setPaymentModeDetails({
            ...payModeDetails,
            ...autoSelectBank,
            bnkName: bankDetailsList[0].bnkName,
            bnkCode: bankDetailsList[0].bnkCode,
            brcName: bankDetailsList[0].brcName,
            bnkAccNo: bankDetailsList[0].bnkAccNo,
            accCode: personaldetails.accountCodeField,
          });
          props.setLoader(false);
        }
      }
    } catch (error) {}
  };
  const onChange = (name?: string, value?: any, accNo?: number) => {
    if (!errorMsg.includes("Minimum transfer amount is Rs.50")) setErrorMsg("");
    if (name !== "paymtMd") {
      setPaymentModeDetails({
        ...payModeDetails,
        paymtMd: "",
        bnkName: "",
        bnkCode: "",
        brcName: "",
        bnkAccNo: "",
        isPrimUpi: false,
      });
      var selectedBankPayMode = [];
      selectedBankPayMode = bankUpiDetails.bankDetails.filter(
        (bankObj: any) => {
          return bankObj.bnkAccNo === accNo;
        }
      );
      setPayOption([selectedBankPayMode[0]]);
      let payObj = {
        ...payModeDetails,
        [`${name}`]: value,
        bnkAccNo: accNo,
        bnkCode: selectedBankPayMode[0].bnkCode,
        brcName: selectedBankPayMode[0].brcName,
      };
      if (selectedBankPayMode[0].fndTrsAvl) payObj.paymtMd = "IB";
      else if (selectedBankPayMode[0].upiintent) payObj.paymtMd = "UPI";
      // else if (selectedBankPayMode[0].upiqr && selectedBankPayMode[0].upiAvl)
      //   payObj.paymtMd = "QR";
      else {
        payObj.paymtMd = undefined;
      }
      if (memorandumDetails.Total_NET_Outstanding > 50) {
        if (!payObj.paymtMd)
          setErrorMsg(
            "We do not have instant fund transfer facility available with the selected bank currently, please try after sometime or you can connect with your respective RM for cheque based payment facility."
          );
      }
      setPaymentModeDetails(payObj);
    } else {
      let payObj = {
        ...payModeDetails,
        [`${name}`]: value,
        upi: "",
      };
      setPaymentModeDetails(payObj);
      setError({
        ...error,
        handleError: "",
      });
    }
  };
  const submitPayment = async () => {
    props.setLoader(true);
    let requestObj = {
      isPrimUpi: payModeDetails.isPrimUpi,
      bnkCode: payModeDetails.bnkCode,
      amt: memorandumDetails.Total_NET_Outstanding,
      bnkAccNo: payModeDetails.bnkAccNo,
      bnkName: payModeDetails.bnkName,
      paymtMd: payModeDetails.paymtMd,
      brcName: payModeDetails.brcName,
      ldgrNm: payModeDetails.ldgrNm,
      upi: payModeDetails.upi,
      app: payModeDetails.app,
      isMmrdm: payModeDetails.isMmrdm,
      srId: "SR-" + props.srId,
      src:
        localStorage.getItem("lgnSrc") == "android-phone"
          ? "MRD-EMTANDROID"
          : localStorage.getItem("lgnSrc") == "iphone"
          ? "MRD-EMTIOS"
          : localStorage.getItem("lgnSrc") == "X"
          ? "tx3"
          : "MRD-web-pc",
      accCode: payModeDetails.accCode,
    };
    try {
      let response = await paymentGateway(requestObj);

      if (response && response.data && JSON.parse(response.data.details).url) {
        window.open(JSON.parse(response.data.details).url, "_self");
      }
      if (response && response.error) {
        setError({
          ...error,
          handleError: response.error.errMsg,
        });
      }
      props.setLoader(false);
    } catch (error) {
      console.log(error);
      accountApiError();
    }
  };
  return (
    <>
      {/* {loader && (
        <div style={{ textAlign: "center", paddingTop: "50px" }}>
          <Loader size={50} color="blue"></Loader>
        </div>
      )} */}
      {!props.loader && (
        <>
          {!props.paymentStatus && (
            <div className="paymentAccount">
              <div className="paymentHead">
                <h4>Pending Debit</h4>
                <p>Outstanding amount pending for your account code</p>
              </div>

              <div className="payment-radioWrap ">
                <label className="input-label payment-label">
                  Pay From Bank Account
                </label>
                <div className="payment-align CheckboxWrap">
                  {bankUpiDetails.bankDetails.map((bankObj: any, i: number) => (
                    <div className="payment-radio custom--row">
                      <div className=" bankAccRadio">
                        <div className="radioBtn_wrap">
                          <RadioButton
                            list={bankObj}
                            name="bnkName"
                            onChange={(e) => {
                              onChange(
                                e.target.name,
                                bankObj.bnkName,
                                bankObj.bnkAccNo
                              );
                            }}
                            selected={payModeDetails.bnkAccNo}
                          />
                          <p>{bankObj.bnkAccNo}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {payOption.length > 0 &&
                payModeDetails.paymtMd &&
                payOption.map((upiObj: any, i: any) => (
                  <div className="payment-radioWrap payMethod">
                    <label className="input-label payment-label">
                      Payment Mode
                    </label>
                    <div className="payment-radio info_radio">
                      {upiObj.fndTrsAvl && (
                        <RadioButton
                          list={payMethod[0]}
                          name="paymtMd"
                          onChange={(e) => {
                            onChange(
                              e.target.name,
                              e.target.value,
                              upiObj.bnkAccNo
                            );
                          }}
                          selected={payModeDetails.paymtMd}
                        />
                      )}
                      {/* {upiObj.upiqr && upiObj.upiAvl && (
                        <RadioButton
                          list={payMethod[2]}
                          name="paymtMd"
                          onChange={(e) => {
                            onChange(
                              e.target.name,
                              e.target.value,
                              upiObj.bnkAccNo
                            );
                          }}
                          selected={payModeDetails.paymtMd}
                        />
                      )} */}
                      {upiObj.upiintent && (
                        <>
                          <RadioButton
                            list={payMethod[1]}
                            name="paymtMd"
                            onChange={(e) => {
                              onChange(
                                e.target.name,
                                e.target.value,
                                upiObj.bnkAccNo
                              );
                            }}
                            selected={payModeDetails.paymtMd}
                          />
                          <div>
                            <div className="display-flex align-center">
                              <a
                                href="#"
                                className="tooltip-right"
                                data-tooltip="E.g. name@bankname"
                              >
                                <i
                                  className="edel-icon-faqs"
                                  onMouseOver={() => {
                                    setHover(true);
                                  }}
                                  onMouseLeave={() => {
                                    setHover(false);
                                  }}
                                ></i>
                              </a>
                              {hover && (
                                <div>
                                  <div className="boxWrapTooltip">
                                    <div className="box">
                                      <div className="arrow arrow-left"></div>
                                      <p>E.g. name@bankname</p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {payModeDetails.paymtMd === "UPI" && (
                      <div className="declarationWrap custom-col-1">
                        <InputField
                          onChange={(val: any) => {
                            setError({
                              ...error,
                              handleError: "",
                            });
                            //primaryUpi condition

                            let primaryUpi: any;
                            if (bankUpiDetails.upiDetails) {
                              primaryUpi = bankUpiDetails.upiDetails.find(
                                (list: any) =>
                                  list.upi === val &&
                                  list.bankaccountnumber ===
                                    payModeDetails.bnkAccNo
                              );
                            }

                            if (upiExp.test(val)) {
                              // let dataup = [...bankUpiDetails.upiHdlInfo];
                              // dataup.push({
                              //   handlelimit: 200000,
                              //   handlename: "@".concat(val.split("@")[1]),
                              // });
                              const checkHandleInfo = "@".concat(
                                val.split("@")[1]
                              );
                              const selectHandle =
                                bankUpiDetails.upiHdlInfo.find(
                                  (list: any) =>
                                    list.handlename === checkHandleInfo
                                );
                              const finalHandle = selectHandle
                                ? selectHandle
                                : bankUpiDetails.upiHdlInfo.find(
                                    (list: any) =>
                                      list.handlename === "@genericupi"
                                  );

                              setBankUpiDetails({
                                ...bankUpiDetails,
                                handleLimit: finalHandle.handlelimit,
                              });
                            }
                            setPaymentModeDetails({
                              ...payModeDetails,
                              isPrimUpi: primaryUpi ? true : false,
                              upi: val,
                            });
                            // let select = bankUpiDetails.upiHdlInfo.find(
                            //   (list: any) => {
                            //     if (list.handlename === checkHandleInfo) {
                            //       if (
                            //         memorandumDetails.Total_NET_Outstanding <=
                            //         list.handlelimit
                            //       ) {
                            // add primaryUPI conditions
                            //       } else {
                            //         setPaymentModeDetails({
                            //           ...payModeDetails,
                            //           upi: "",
                            //           isPrimUpi: false,
                            //         });
                            //       }
                            //     }
                            //   }
                            // );
                          }}
                          onMouseOut={(val) => {
                            if (val) {
                              if (upiExp.test(val)) {
                                console.log(
                                  memorandumDetails.Total_NET_Outstanding <=
                                    payModeDetails.handleLimit,
                                  memorandumDetails.Total_NET_Outstanding,
                                  bankUpiDetails.handleLimit
                                );

                                if (
                                  memorandumDetails.Total_NET_Outstanding >
                                  bankUpiDetails.handleLimit
                                ) {
                                  setError({
                                    ...error,
                                    handleError: `Max. Transfer amount is Rs ${bankUpiDetails.handleLimit.toLocaleString(
                                      "en-IN"
                                    )}`,
                                  });
                                } else {
                                  setError({
                                    ...error,
                                    handleError: "",
                                  });
                                }
                              } else {
                                setError({
                                  ...error,
                                  handleError:
                                    "UPI ID should be in the format name@bankname.",
                                });
                              }
                            }
                          }}
                          onBlur={() => {}}
                          errorText={error.handleError}
                          placeholder="Enter UPI ID linked to above account"
                          pattern={upiExp}
                        />
                      </div>
                    )}
                  </div>
                ))}

              <div />
              <div className="blue-bgBox">
                <p>
                  Amount to Paid &#8377;
                  <span>
                    {" " +
                      memorandumDetails.Total_NET_Outstanding.toLocaleString(
                        "en-IN"
                      )}
                  </span>
                </p>
              </div>
              {errorMsg && <p className={`error-msg`}>{errorMsg}</p>}
              <div className="modal-footer common-modal--footer">
                <div className="mob-center">
                  <button
                    type="button"
                    className="btn btn-blue login-btn"
                    onClick={submitPayment}
                    disabled={
                      !(payModeDetails.bnkName && payModeDetails.bnkAccNo) ||
                      !(payModeDetails && payModeDetails.paymtMd) ||
                      (payModeDetails.paymtMd === "UPI" &&
                      (error.handleError || !payModeDetails.upi)
                        ? true
                        : false) ||
                      errorMsg
                    }
                  >
                    Pay
                  </button>
                  <button type="submit" className="btn btn-olink login-btn">
                    <a
                      className="btn btn-olink login-btn"
                      href={
                        RedirectnSource == "onep-sr" 
                        ? config.onePlatformBase + "service-request" 
                        : config.rootUrl + "clientarea/servicerequest"
                      }
                    >
                      Cancel
                    </a>
                  </button>
                </div>
              </div>
              <div className="text text--payment">
                <p className="reminderText">Queries on this Payment</p>
                <p>
                  <a
                    onClick={async (e: any) => {
                      e.preventDefault();
                      props.setLoader(true);
                      let reqRm = {
                        requestType: "ContactRM",
                        parent_id: props.srId,
                        memorandumId: memorandumDetails.memorandumId,
                      };
                      let contactRm = await updateAccReactStatus(reqRm);
                      if (
                        contactRm &&
                        contactRm.Message ===
                          "Memmorandum SR successfully assigne to RM"
                      )
                        props.onSubmit("AccountPayment", {
                          headerText: "We have received your request!",
                          content: "We have received your request for reactivation of your account. This request will be processed in 2-3 business days.",
                          popupType: "Success"
                        });
                      props.setLoader(false);
                    }}
                  >
                    Contact your RM
                  </a>
                </p>
                <p className="reminderText">
                  Or write to us on{" "}
                  <a
                    href="mailto:helpdesk@nuvama.com"
                    className="mail_link bold-text"
                  >
                    helpdesk@nuvama.com
                  </a>
                </p>
              </div>
            </div>
          )}
          {props.paymentStatus && <StatusScreen status={status} />}
        </>
      )}
    </>
  );
};
